import type { Contact } from '@/shared/types/api'

import { contactToVCard } from './contact-to-vcard'
import type { ContactToVCardOverrides } from './contact-to-vcard'

const sanitizeFilename = (name: string): string =>
  name.replace(/[^\p{L}\p{N}\s_-]/gu, '').trim() || 'contact'

export const contactToVCardFile = (contact: Contact, overrides?: ContactToVCardOverrides): File => {
  const vcard = contactToVCard(contact, overrides)
  const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' })
  return new File([blob], `${sanitizeFilename(contact.name)}.vcf`, { type: 'text/vcard;charset=utf-8' })
}

export const downloadContactAsVCard = (contact: Contact, filename?: string, overrides?: ContactToVCardOverrides): void => {
  const vcard = contactToVCard(contact, overrides)
  const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename ?? `${sanitizeFilename(contact.name)}.vcf`
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
